// Core packages
import * as tslib_1 from "tslib";
// Third party packages
// Custom packages
import { BaseModel } from '../_base/model.class';
/**
 * Script start
 */
var Ddt = /** @class */ (function (_super) {
    tslib_1.__extends(Ddt, _super);
    function Ddt(_id, code, status, createdAt) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this.code = code;
        _this.status = status;
        _this.createdAt = createdAt;
        _this.setRequiredFields([
            '_id',
            'code',
            'status',
            'createdAt',
        ]);
        return _this;
    }
    return Ddt;
}(BaseModel));
export { Ddt };
